module.exports = {
  BatchImportOrders: 'Nhập hàng loạt đơn hàng',
  BatchExportOrders: 'Xuất hàng loạt đơn hàng',
  BatchExportBills: 'Xuất hàng loạt hóa đơn',
  BusinessDate: 'Ngày nghiệp vụ',
  OperationDate: 'Ngày thao tác',
  BillCreationDate: 'Ngày tạo hóa đơn',
  BillInvoicingDate: 'Ngày xuất hóa đơn',
  BillReceivingDate: 'Ngày nhận hóa đơn',
  BillVoucherGenerationDate: 'Ngày tạo chứng từ hóa đơn',
  BillNo: 'Số hóa đơn',
  BusinessStatus: 'Trạng thái nghiệp vụ',
  BusinessType: 'Loại nghiệp vụ',
  OperatingBranch: 'Chi nhánh thao tác',
  ExportSettings: 'Thiết lập xuất',
  AccountsReceivableBills: 'Hóa đơn phải thu',
  AccountsPayableBills: 'Hóa đơn phải trả',
  ExportConditions: 'Điều kiện xuất',
  ReminderExportedAtOnce1000: 'Lưu ý: Số dòng xuất mỗi lần không vượt quá 1000 dòng',
  ConfirmExport: 'Xác nhận xuất',
  ExportSuccessful: 'Xuất thành công',
  BusinessCreationDate: 'Ngày tạo nghiệp vụ',
  Operation: 'Thao tác',
  BusinessNumber: 'Mã nghiệp vụ',
  DirectOrder: 'Có phải đơn trực tiếp',
  MasterBillNumber: 'Số vận đơn chính',
  MasterBillSerialNumber: 'Số serial vận đơn chính',
  OceanFreight: 'Vận tải biển',
  OceanExport: 'Xuất khẩu đường biển',
  OceanImportdirectOrder: 'Nhập khẩu đường biển (đơn trực tiếp)',
  AirFreight: 'Vận tải hàng không',
  AirExport: 'Xuất khẩu đường hàng không',
  AirImportdirectOrder: 'Nhập khẩu đường hàng không (đơn trực tiếp)',
  All: 'Tất cả',
  Yes: 'Có',
  No: 'Không',
  DownloadExportResults: 'Tải xuống kết quả xuất',
  EnterAirImport: 'Vào nhập khẩu hàng không',
  EnterAirExport: 'Vào xuất khẩu hàng không',
  EnterOceanImport: 'Vào nhập khẩu đường biển',
  EnterOceanExport: 'Vào xuất khẩu đường biển',
  DownloadCompleted: 'Tải xuống hoàn tất',
  Return: 'Quay lại',
  File: 'Tệp',
  ImportSettings: 'Thiết lập nhập',
  OceanImport: 'Nhập khẩu đường biển',
  AirCargoImport: 'Nhập khẩu hàng không',
  ImportFile: 'Tệp nhập',
  SelectFile: 'Chọn tệp',
  DownloadTemplate: 'Tải xuống mẫu',
  ReminderCannotExceed100Lines: 'Lưu ý: Số dòng nhập mỗi lần không vượt quá 100 dòng',
  ConfirmImport: 'Xác nhận nhập',
  AirCargoImportTemplate: 'Mẫu nhập khẩu hàng không',
  UploadedInXLSOrFormat: 'Tệp tải lên chỉ có thể là định dạng XLS hoặc XLSX!',
  DownloadImportResult: 'Tải xuống kết quả nhập',
  DownloadComplete: 'Tải xuống hoàn tất',
  EnterAirCargoImport: 'Vào nhập khẩu hàng không',
  EnterSeaCargoImport: 'Vào nhập khẩu đường biển',
  TotalRecordsMeetTheConditions: 'Có tổng cộng {0} dòng đáp ứng điều kiện xuất',
  N0TheConditionsAndExported: 'Có {0} dòng không đủ điều kiện sẽ không xuất',
  Success0entriesFailure0entries: 'Thành công {0} dòng, thất bại {1} dòng.'
}
